module.exports = "<div [className]=\"email.unreadClass\">{{email.from_name}}\n\n<span *ngIf=\"email.attachments\" class=\"attachment-icon glyphicon glyphicon-paperclip\"></span>\n\n<br/>\n<{{email.from_address}}><br/>\n{{email.received}}<br/>\n<em>{{email.subject}}</em>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/mailbox-email/mailbox-email.component.html
// module id = ../../../../../src/app/mailbox-email/mailbox-email.component.html
// module chunks = 1